export const launch7Campaign = '?utm_source=faithlifetv.com&utm_medium=branding-bug&utm_campaign=launch-stream';
export const productPageCampaign = '';
